module.exports = __webpack_public_path__ + "static/media/lp2-image-1.b4e34fc0.png";